<template>
  <p class="sword-success-text-wuk">
    <sword-icon-wuk name="circle-check" />
    <span>{{ text }}</span>
  </p>
</template>

<script>
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'SuccessText',
  components: { SwordIconWuk },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .sword-success-text-wuk {
    @include input-footer-wrapper-wuk;

    color: $input-success-color;

    .sword-icon.svg-icon {
      height: $input-success-icon-size;
      width: $input-success-icon-size;
    }
  }
</style>
